import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTableViews = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 14.2L0 7.6L12 1L24 7.6L12 14.2ZM12 18.6L0.627273 12.3575L2.91818 11.0925L12 16.0975L21.0818 11.0925L23.3727 12.3575L12 18.6ZM12 23L0.627273 16.7575L2.91818 15.4925L12 20.4975L21.0818 15.4925L23.3727 16.7575L12 23ZM12 11.6975L19.4455 7.6L12 3.5025L4.55455 7.6L12 11.6975Z",
		fill: "currentColor"
	})
});
export default SvgTableViews;
